import { useState, useEffect } from "react";
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

function LocalMoving() {
  const [LocalMovingData, setLocalMovingData] = useState('')
  const [HeadingUpdate, setHeadingUpdate] = useState('')
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null)
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }


  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "Local Moving"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        setLocalMovingData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id)
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id)
  };


  const TextHandle = () => {
    if (HeadingUpdate === '') {
      message.error('Fill the Field')
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId
      })
      setTextModalVisible(false);
      setHeadingUpdate('')
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error('Insert Image')
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId
      })
      setImageModal(false);
    }
  };

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };


  const OnEnterPress = (event) => {
    const a = HeadingUpdate
    console.log(a)
    if (event.key === 'Enter') {
      console.log('Enter Clicked')
      a.concat('\n')
      setHeadingUpdate(a)
    } else {
      console.log(event.key)
    }
  }


  return (
    <Layout>
      {LocalMovingData && <Header
        UpdateText={UpdateText}
        UpdateImage={UpdateImage}
        GetData={{
          imgId: LocalMovingData.section1image1._id,
          headingId: LocalMovingData.section1heading1._id
        }}
        Image={LocalMovingData.section1image1.image} />}

      {LocalMovingData && <div className='LocalMoving-Container'>
        <div className='section-1'>
          <div className='Image'>
            <i onClick={() => showImageModal(LocalMovingData.section2image1._id)} className="far fa-edit Edit-btn"></i>
            <img src={`${url}/api/getFile${LocalMovingData.section2image1.image}`} alt='Img' />
          </div>
          <div className='Info'>
            <h2> {LocalMovingData.section2heading1.content}
              <i onClick={() => ShowTextModal(LocalMovingData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
            </h2>
            <div className='LM-list'>
              <p> {LocalMovingData.section2paragraph1.content}</p>
              <i onClick={() => ShowTextModal(LocalMovingData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </div>
            {/* <button className='Secondary-btn Button'>Learn More</button> */}
          </div>
        </div>
        <div className='section-1 section-right'>
          <div className='Image'>
            <i onClick={() => showImageModal(LocalMovingData.section3image1._id)} className="far fa-edit Edit-btn"></i>
            <img src={`${url}/api/getFile${LocalMovingData.section3image1.image}`} alt='Img' />
          </div>
          <div className='Info2'>
            <div className='l-1'></div>
            <div className='r-1'>
              <h2> {LocalMovingData.section3heading1.content}
                <i onClick={() => ShowTextModal(LocalMovingData.section3heading1._id)} className="far fa-edit Edit-btn"></i>
              </h2>
              <div className='LM-list'>
                <p> {LocalMovingData.section3paragraph1.content}</p>
                <i onClick={() => ShowTextModal(LocalMovingData.section3paragraph1._id)} className="far fa-edit Edit-btn"></i>
              </div>
              {/* <button className='Secondary-btn Button'>Learn More</button> */}
            </div>
          </div>
        </div>
        <div className='section-1'>
          <div className='Image'>
            <i onClick={() => showImageModal(LocalMovingData.section4image1._id)} className="far fa-edit Edit-btn"></i>
            <img src={`${url}/api/getFile${LocalMovingData.section4image1.image}`} alt='Img' />
          </div>
          <div className='Info'>
            <h2> {LocalMovingData.section4heading1.content}
              <i onClick={() => ShowTextModal(LocalMovingData.section4heading1._id)} className="far fa-edit Edit-btn"></i>
            </h2>
            <div className='LM-list'>
              <p> {LocalMovingData.section4paragraph1.content}</p>
              <i onClick={() => ShowTextModal(LocalMovingData.section4paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </div>
            {/* <button className='Secondary-btn Button'>Learn More</button> */}
          </div>
        </div>
      </div>}

      {
        LocalMovingData && <GetQuoteForm UpdateImage={UpdateImage} 
        imageID={LocalMovingData.image._id} image={LocalMovingData.image.image} />
      }

      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default LocalMoving;
